import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function MenuItemDetail() {
  const { slug } = useParams();
  const [item, setItem] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setItem(null);
    setNotFound(false);
    axios
      .get(`${API}/menu/${slug}`)
      .then((r) => setItem(r.data))
      .catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) {
    return (
      <div className="py-32 text-center" data-testid="menu-item-not-found">
        <h1 className="text-4xl font-display text-[#cd0202]">Item not found</h1>
        <Link to="/highlights" className="sd-btn-red mt-6 inline-block">Back to Menu</Link>
      </div>
    );
  }

  if (!item) return <div className="py-32 text-center" data-testid="loading">Loading...</div>;

  return (
    <div data-testid={`menu-detail-${item.slug}`}>
      <section className="sd-page-hero">
        <h1>{item.name}</h1>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-5xl mx-auto px-6 grid md:grid-cols-2 gap-10 items-start">
          <img
            src={item.image}
            alt={item.name}
            className="w-full rounded shadow-lg"
            data-testid="menu-detail-image"
          />
          <div>
            <Link to="/highlights" className="inline-flex items-center text-[#cd0202] mb-4">
              <ChevronLeft size={20} /> Back to menu
            </Link>
            <h2 className="text-3xl text-[#cd0202] mb-4 font-display">{item.name}</h2>
            <p className="text-gray-700 leading-relaxed mb-6">{item.description}</p>
            <p className="text-2xl font-display text-[#cd0202] mb-8">{item.price_label}</p>
            <Link
              to={`/order?item=${item.slug}`}
              className="sd-btn-red"
              data-testid="menu-detail-order-btn"
            >
              Order Now
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
